import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import TableTemplate from "../../../../Components/Table/TableTemplate";
import { WebRoutes } from "../../../../Constants";
import { SCHOOL_RETURNS } from "../../../../Constants/Endpoints";
import { SchoolStatusCell } from "../../../../Components/SchoolStatusCell/SchoolStatusCell";
import {
  addSchoolFlowParams,
  addSchoolFlowWithFileParams,
  deleteSchoolFlowParams,
  getAllSchoolsSimpleRequest,
} from "../../../../Backend/SchoolsRequests";
import { AddSchoolFlowModal } from "./AddSchoolFlowModal/AddSchoolFlowModal";
import "./SchoolReturns.scss";

export function SchoolReturns() {
  const tableTemplateRef = useRef(null);
  const [t] = useTranslation();
  const navigate = useNavigate();

  const [showAddModal, setShowAddModal] = useState(false);
  const [allSchools, setAllSchools] = useState([]);
  const [error, setError] = useState("");

  const [columns] = useState([
    {
      name: "school.schoolNumber",
      headerCaption: t("SchoolNumber"),
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "school.name",
      headerCaption: t("Name"),
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "year",
      headerCaption: t("Year"),
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "firstScanCompleted",
      headerCaption: t("Flow1"),
      textAlign: "center",
      canSort: false,
      canFilter: false,
      canEdit: false,
      caption: (x) =>
        !x.haveThirdScan ? (
          <div className="flow-wrapper">
            <SchoolStatusCell status={x.firstScanCompleted} />
            <div
              className="is-checkbox pointer"
              title={t("ManageFlow1")}
              onClick={() =>
                navigate(
                  WebRoutes.SchoolPackageReturns.replace(":id", x.schoolId)
                )
              }
            >
              settings
            </div>
          </div>
        ) : (
          <div className="flow-wrapper">-</div>
        ),
    },
    {
      name: "secondScanCompleted",
      headerCaption: t("Flow2"),
      textAlign: "center",
      canSort: false,
      canFilter: false,
      canEdit: false,
      caption: (x) =>
        !x.haveThirdScan ? (
          <div className="flow-wrapper">
            <SchoolStatusCell status={x.secondScanCompleted} />
            {x.firstScanCompleted && (
              <div
                className="is-checkbox pointer"
                title={t("ManageFlow2")}
                onClick={() =>
                  navigate(
                    WebRoutes.SchoolBookPurchase.replace(
                      ":schoolId",
                      x.school.id
                    ).replace(":id", x.id)
                  )
                }
              >
                settings
              </div>
            )}
          </div>
        ) : (
          <div className="flow-wrapper">-</div>
        ),
    },
    {
      name: "haveThirdScan",
      headerCaption: t("Flow3"),
      textAlign: "center",
      canSort: false,
      canFilter: false,
      canEdit: false,
      caption: (x) =>
        x.haveThirdScan ? (
          <div className="flow-wrapper">
            <SchoolStatusCell status={x.thirdScanCompleted} />
            <div
              className="is-checkbox pointer"
              title={t("ManageFlow3")}
              onClick={() =>
                navigate(
                  WebRoutes.SchoolBookPurchaseQuantity.replace(
                    ":schoolId",
                    x.school.id
                  ).replace(":id", x.id)
                )
              }
            >
              settings
            </div>
          </div>
        ) : (
          <div className="flow-wrapper">-</div>
        ),
    },
  ]);

  useEffect(() => {
    getAllSchools();
  }, []);

  const getAllSchools = async () => {
    const resp = await getAllSchoolsSimpleRequest();

    if (resp.success) {
      setAllSchools(resp.data);
    }
  };

  const addSchoolFlowWithFile = async (newFlow) => {
    let data = await addSchoolFlowWithFileParams(newFlow);
    if (data.success) {
      tableTemplateRef.current.getItems();
      toggleAddModal();
    } else {
      setError(data.errors[0].errorMessageKey);
    }
  };

  const deleteSchoolFlow = async (row) => {
    let data = await deleteSchoolFlowParams({ id: row.id });
    if (data.success) {
      tableTemplateRef.current.getItems();
    }
  };

  const toggleAddModal = () => {
    setError("");
    setShowAddModal(!showAddModal);
  };

  return (
    <div className="school-returns-page">
      <TableTemplate
        ref={tableTemplateRef}
        title={t("Schools")}
        endpoint={SCHOOL_RETURNS}
        columns={columns}
        addItem={() => toggleAddModal()}
        onDelete={deleteSchoolFlow}
        uniqueId="schoolNumber"
        paginator={true}
      />

      {showAddModal && (
        <AddSchoolFlowModal
          show={showAddModal}
          allSchools={allSchools}
          error={error}
          submit={(newFlow) => addSchoolFlowWithFile(newFlow)}
          onHide={() => toggleAddModal()}
        />
      )}
    </div>
  );
}
